// TODO: Make Slides loadable
// TODO: Separate single slide shell and make loadable
export { default } from './Slides';
